__turbopack_context__.v({
  "loader": "QKF5sG_loader",
  "spin": "QKF5sG_spin",
});
